document.addEventListener('DOMContentLoaded', () => {
  const input = document.querySelector('.faq-search-header [type="search"]')
  const accordionSection = document.querySelectorAll('.faq-accordion')
  const anchorImageParent = document.querySelector('.anchors-parent') || null
  const categoryHeaders = document.querySelectorAll('.faq-accordion-category') || null
  let timeoutId

  input.addEventListener('input', (e) => {
    input.parentElement.classList.add('searching')

    if (timeoutId) {
      clearTimeout(timeoutId)
    }
    timeoutId = setTimeout(() => {
      searchFAQs(e.target.value)
      input.parentElement.classList.remove('searching')
    }, 350)
  })

  if (window.location.search.includes('faq-helper')) {
    const urlParams = new URLSearchParams(window.location.search)
    const helperString = urlParams.get('faq-helper')

    input.value = helperString
    searchFAQs(helperString)
  }

  function searchFAQs(query) {
    const regex = new RegExp(query, 'i')

    accordionSection.forEach((section) => {
      let counter = section.children.length - 1 // -1 to account for the header

      section.querySelectorAll('.accordion-item').forEach((item) => {
        if (regex.test(item.textContent)) {
          item.style.display = 'block'
        } else {
          item.style.display = 'none'
          counter--
        }

        counter === 0 ? (section.style.display = 'none') : (section.style.display = 'flex')

        if (query === '') {
          // show anchor image section if it exist
          if (anchorImageParent) {
            anchorImageParent.style.display = 'block'
          }
          // show headers if they exist
          if (categoryHeaders) {
            categoryHeaders.forEach((header) => {
              header.style.display = 'block'
            })
          }
        } else {
          // hide headers if they exist
          if (categoryHeaders) {
            categoryHeaders.forEach((header) => {
              header.style.display = 'none'
            })
          }

          // hide anchor image section if it exist
          if (anchorImageParent) {
            anchorImageParent.style.display = 'none'
          }
        }
        checkIfEmptyResults()
      })
    })
  }

  function checkIfEmptyResults() {
    for (i = 0; i < accordionSection.length; i++) {
      if (accordionSection[i].style.display === 'flex') {
        if (document.querySelector('.no-results')) {
          document.querySelector('.no-results').remove()
        }
        return
      }
    }

    const noResults = `
      <div class="no-results faq-padding">
        <p>No results found, sorry! Try searching for something else.</p>
      </div>
    `
    document.querySelector('.faq-search-header').parentNode.parentNode.insertAdjacentHTML('afterEnd', noResults)
  }
})
